import { render, staticRenderFns } from "./TaskBlockCommentParent.vue?vue&type=template&id=4f2f7aca&scoped=true&"
import script from "./TaskBlockCommentParent.vue?vue&type=script&lang=js&"
export * from "./TaskBlockCommentParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2f7aca",
  null
  
)

export default component.exports